export default __webpack_public_path__ + "static/media/YAS0580.34I-30576_-17588_0.a1ab53e6.jpg";